export const redirectToSalesOrderConfirmationPage = (slug: string) => {
  window.open(`/ground-control/sales-order/${slug}/confirm/`, '_self');
};
